import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {format} from 'date-fns';
//@ts-ignore
import * as Handlebars from 'handlebars/dist/cjs/handlebars';


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

Handlebars.registerHelper('toDate', function (dateStr: string, dateFmt: string) {
  return format(new Date(dateStr), dateFmt);
});
